import { LABELS } from "~/resources/Labels";
import { TableHeaderType } from "../types/TableHeaderType";

export const ContractHeader: TableHeaderType[] = [
    {
      label: LABELS.ContractID,
      key: 'requesterUniqueId',
      id: 'requesterUniqueId',
      sortable: true,
      alignment:'center'
    },
    {
      id: 'provisionedDateTime',
      label: LABELS.ProvisioningDate,
      alignment: 'center',
      sortable: true,
      key: 'provisionedDateTime',
    },

    {
      id: 'resourceStatus',
      label:LABELS.Status,
      alignment: '',
      sortable: true,
      key: 'resourceStatus',
    },
    {
        id: 'decomissionedDateTime',
        label: LABELS.DecommisioningDate,
        alignment: '',
        sortable: true,
        key: 'decomissionedDateTime',
      },
  ];
